import { render } from "./MultiInputLanguageComponent.vue?vue&type=template&id=90cec034"
import script from "./MultiInputLanguageComponent.vue?vue&type=script&lang=js"
export * from "./MultiInputLanguageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/MultiInputLanguageComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "90cec034"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('90cec034', __exports__)) {
    api.reload('90cec034', __exports__)
  }
  
  module.hot.accept("./MultiInputLanguageComponent.vue?vue&type=template&id=90cec034", () => {
    api.rerender('90cec034', render)
  })

}


export default __exports__